import React from 'react';
import {Typography} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {useFormikContext} from "formik";
import OperateurSelect from "../../layout/forms/OperateurSelect";

const iri = (o) => o["@id"];

function CampaignOperateursField({...props}) {
    const {values, errors, operateurs} = props;
    const {setFieldValue} = useFormikContext();

    return (
        <Grid container size={12} spacing={1} className={"sectionContainer"}>
            <Grid size={12}>
                <Typography variant={"h5"} className={"sectionHeader"}>Sélection des opérateurs</Typography>
            </Grid>

            {/* CHAUFFEUR FIELD*/}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    <Typography>Sélectionner le chauffeur *</Typography>
                </Grid>
                <Grid size={9}>
                    <OperateurSelect
                        label="Sélectionner le chauffeur :"
                        operateurs={operateurs ?? []}
                        getOptionValue={iri}
                        value={values.chauffeur}
                        error={Boolean(errors.chauffeur)}
                        helperText={errors.chauffeur && String(errors.chauffeur) ? errors.chauffeur : undefined}
                        onChange={(v) => {
                            setFieldValue("chauffeur", v);
                            // Le chauffeur ne peut pas être aussi l'équipier
                            if (values.equipier && values.equipier === v) {
                                setFieldValue("equipier", "");
                            }
                        }}
                    />
                </Grid>
            </Grid>

            {/* EQUIPIER FIELD*/}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    <Typography>Sélectionner l'équipier (optionnel)</Typography>
                </Grid>
                <Grid size={9}>
                    <OperateurSelect
                        label="Sélectionner l'équipier :"
                        allowNone
                        operateurs={(operateurs ?? []).filter((o) => o["@id"] !== values.chauffeur)}
                        getOptionValue={iri}
                        value={values.equipier || ""}
                        error={Boolean(errors.equipier)}
                        helperText={errors.equipier && String(errors.equipier) ? errors.equipier : undefined}
                        onChange={(v) => setFieldValue("equipier", v)}
                    />
                </Grid>
            </Grid>

        </Grid>
    );
}

export default CampaignOperateursField;
